import type { ReactNode } from 'react';
import { Stepper } from './Stepper';

/** 64px desktop header: wordmark + eyebrow · stepper · contextual right slot. */
export function Header({
  step,
  right,
  onStepClick,
  onActiveStepClick,
  activeStepTitle,
  stepperForward,
}: {
  step: number;
  right?: ReactNode;
  onStepClick?: (step: number) => void;
  stepperForward?: number[];
  onActiveStepClick?: () => void;
  activeStepTitle?: string;
}) {
  return (
    <header className="hdr">
      <div className="hdr__brand hdr__brand--stacked">
        <span className="hdr__wordmark">Rewind Photo Lab</span>
        <span className="hdr__eyebrow">Print Portal</span>
      </div>
      <Stepper
        step={step}
        onStepClick={onStepClick}
        forward={stepperForward}
        onActiveClick={onActiveStepClick}
        activeTitle={activeStepTitle}
      />
      <div className="hdr__right">{right}</div>
    </header>
  );
}
